<template>
  <el-container class="ht100">
    <el-aside :style="subNavDynamicStyle">
      <div class="subNav_Title">
        <h3>个人设置</h3>
      </div>
      <el-menu
        background-color="#f7f8fa"
        style="border-right: none"
        router
        :default-active="$route.path"
      >
        <el-menu-item v-for="(item) in routeData" :key="item.path" :index="item.path">
            <span slot="title">{{ $t(item.name) }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 导航栏收缩小按钮 -->
    <div
      id="iconSubShrink"
      class="system-icon-sub-shrink"
      style="cursor:pointer;"
      :style="iconDynamicStyle"
      @click="clickIconSubShrink()"
    >
      <svg class="icon" aria-hidden="true" :style="iconRotateDynamicStyle">
        <use xlink:href="#iconretract-arrow" />
      </svg>
    </div>

    <!-- 右侧主体面板:通过动态路由加载 -->
    <el-container>
      <el-main style="height: calc(100% - 60px);">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  name: 'Setting',
  data() {
    return {
      msg: '系统管理',
      // 导航栏收缩涉及的动态样式
      shrinkSubNav: true,
      subNavDynamicStyle: {
        width: '170px',
        height: '100%',
        display: 'block',
        background: '#f7f8fa',
        'border-right': '1px solid #e1e3e6'
      },
      iconDynamicStyle: { left: '149px' },
      iconRotateDynamicStyle: { transform: 'rotate(0deg)' },
      routeData: []
    }
  },
  mounted() {
    // 获取子菜单权限
    this.routeData = this.$authUtis.getModuleMenu('/setting')
    this.routeData = this.routeData.filter(item => item.show !== 'false')
  },
  methods: {
    // 收缩或展开侧边导航栏
    clickIconSubShrink() {
      if (this.shrinkSubNav) {
        this.subNavDynamicStyle = { display: 'none' }
        this.iconDynamicStyle = { left: '0px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(180deg)' }
        this.shrinkSubNav = false
      } else {
        this.subNavDynamicStyle = {
          width: '170px',
          height: '100%',
          display: 'block',
          background: '#f7f8fa',
          'border-right': '1px solid #e1e3e6'
        }
        this.iconDynamicStyle = { left: '149px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(0deg)' }
        this.shrinkSubNav = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  position: relative;
  display: inline-block;
  padding-top: 12px;

  &:after{
     content: "";
     position: absolute;
     left: 0;
     bottom: -11px;
     z-index: 1;
     width: 110%;
     height: 1px;
     background-color: #337eff;
   }
}
.subNav_Title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
}
.system-icon-sub-shrink {
  position: absolute;
  font-size:12px;
  left: 149px;
  top: 50%;
  z-index: 3;
  width: 20px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background-color: #fff;
  color: #8796a6;
  border-radius: 4px 0 4px 0;
  box-shadow: 0 0 10px #eaebee;
  transition: left 0.1s;
}
.el-menu-item{
  text-align: center;
}
.el-divider--horizontal{
  margin: 10px 5px;
}
</style>
